var React = require('react');

function IcCaretUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m16 14-4-4-4 4h8Z","fill":"currentColor"}));
}

IcCaretUp.defaultProps = {"width":"24","height":"24"};

module.exports = IcCaretUp;

IcCaretUp.default = IcCaretUp;
